export const compaction_ng = [

    {
        "A": "03-65",
        "B": "Compaction of Natural Ground",
        "C": 100,
        "D": 0,
    }
]